/*
 * Copyright (c) 2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Card } from "reactstrap";
import { GuestProfileTableLabel } from "./GuestProfile";
import SortableTable from "../../elements/SortableTable";
import BarChart from "../../dashboard/components/barCharts/BarChart";

const groupByMonth = (data, timeKey="createdAt") => {
  if (timeKey == null || data == null) {
    return [];
  }

  const currentDate = new Date();
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  const months = [];
  let tempDate = new Date(sixMonthsAgo);
  while (tempDate <= currentDate) {
      const month = tempDate.toLocaleString('default', { month: 'short' });
      const year = tempDate.getFullYear();
      months.push(`${month} ${year}`);
      tempDate.setMonth(tempDate.getMonth() + 1);
  }

  const groupedData = months.map((month) => {
    const monthData = data.filter((item) => {
        if (item[timeKey] == null) {
          return false;
        }

        const date = new Date(item[timeKey] * 1000);
        return date.toLocaleString('default', { month: 'short' }) + ' ' + date.getFullYear() === month;
    });

    const sum = monthData.reduce((acc, curr) => acc + 1, 0);

    return { name: month, visits: sum };
  });

  return groupedData;
};

const GuestProfileVisitHistory = ({
  guest,
}) => {

  // table columns
  const renderTableLabel = ({ index, data, id, value }) => {
    return <GuestProfileTableLabel key={index}>{value}</GuestProfileTableLabel>;
  };

  // constants
  const columns = [
    { id: "date", name: "Date", type: "time", render: renderTableLabel },
    { id: "session", name: "Session Time", type: "time.session", render: renderTableLabel },
    { id: "upload", name: "Upload", type: "bytes", render: renderTableLabel },
    { id: "download", name: "Download", type: "bytes", render: renderTableLabel },
  ]; 
  // const initialSortKey = "createdAt"; TODO REMOVE

  // Values
  const visitHistory = guest.visitList.map(item => {
    return {
      date: item.createdAt,
      session: item.sessionTime,
      download: item.bytesIn,
      upload: item.bytesOut,
    }
  });

  const dataKeys = [
    { name: "Visits", key: "visits" },
  ];

  const data = groupByMonth(guest.visitList, "createdAt");

  const props = {
    height: `${300 + Math.random()}px`
  }

  return (
    <Card className="p-2 flex-column d-flex fill-container" style={{height: '600px', border: "1px"}}>
      <SortableTable
        data={visitHistory}
        columns={columns}
        filter={{ string: null }}
        initialSortKey={"date"}
        initialSortAscend={false}
        selectValue={null}
      />
      <div key="guest_visit" className="m-2" style={{...props}}>
        <BarChart
          title="Visits"
          type="bar"
          data={data}
          dataKeys={dataKeys}
          {...props}
        />
      </div>
    </Card>
  );
};

export default GuestProfileVisitHistory;